<template>
    <div>
        <el-form
        :model="selectForm"
        ref="ruleForm"
        label-width="80px"

      >
         <el-row :gutter="24">
             <el-col span="6">
                <el-form-item label="标准名称" prop="name">
                        <el-input clearable v-model="selectForm.name" placeholder="标准名称" maxlength="20"></el-input>
                </el-form-item>
            </el-col>

            <el-col span="18">
                <div style="float:right">
                              <el-button icon="el-icon-search" type="primary" @click="search" size="small"> 搜索 </el-button>
                              <el-button @click="searchClear" icon="el-icon-delete" size="small"> 清空 </el-button>
                </div>
            </el-col>

          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            ref="crud"
            @current-change="currentChange"
            @selection-change="selectionChange"
            @size-change="sizeChange"
            @on-load="onLoad()"
            @refresh-change="onLoad()">

            <template slot="choice" slot-scope="scope">
                <el-radio v-model="radio" :label="scope.row" > {{' '}}</el-radio>
            </template>

        </avue-crud>
        <div class="btnArea" style="text-align:right">
            <el-button type="primary" size="small" @click="submitData">提交</el-button>
            <el-button size="small" @click="cancelOperate">取消</el-button>
         </div>
       </el-row>
        </el-form>
    </div>
</template>

<script>
import {getList} from '@/api/crmedical/device/deviceInspectionStandard';
export default {
    props:["projectId",'inspectIdList'],
  data() {
    return {
      standardList:[],
      data: [], //数据源列表
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectForm: {},
      loading: false,
      option: {
        page: true,
        height: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        selection:true,
        column: [

          {
            label: '标准名称',
            prop: 'name',
            searchSpan:6,
          },
          {
            label: '创建人',
            prop: 'realName',
          },
          {
            label: '创建时间',
            prop: 'createTime',
            format: 'yyyy-MM-dd',
            type: 'date',
          },
        ],
      },
    };
  },
  created(){

  },
  methods: {
    selectionChange(e){
      console.log("dddszx")
      this.standardList = e
    },
    sizeChange(pageSize) {
            this.page.pageSize = pageSize;

        },
        currentChange(currentPage) {
            this.page.currentPage = currentPage;

        },
      search(){
          this.page.currentPage = 1
          this.onLoad()
      },
      searchClear(){
          this.$set(this.selectForm,"name",'')
      },
    onLoad() {

      this.loading = true;
      console.log('projectId',this.projectId)
      getList(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize ,status:1,projectId:this.projectId},
          this.selectForm
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          //解决已选标准显示问题
          let rowList = []
          this.inspectIdList.forEach(item => {
            this.data.forEach(item2=>{
              if(item==item2.id){
                rowList.push(item2)
              }
            })
          });
          this.$nextTick(()=>{
            if(rowList.length>0){
              rowList.forEach(row=>{
                this.$refs['crud'].$refs['table'].toggleRowSelection(row)
              })
            }
          })


          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    submitData(){
      console.log("选中的标准",this.standardList)
       this.$emit('choiceData', this.standardList);
    },
    cancelOperate(){
      this.$emit("cancelOperate")
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table--small{
  height:300px!important;
}
</style>
